<template>
    <el-dialog :title="title" :visible.sync="showModal" v-if="showModal" :close-on-click-modal="false"
        :destroy-on-close="true" width="980px">
        <el-form :rules="rules" ref="form" :model="form" label-position="right" label-width="110px">
            <!-- <div style="display:flex; align-items: center;"> -->
            <el-form-item label="测评类型" prop="type">
                <el-select v-model="form.type" placeholder="请选择" :disabled="already_issues_num > 0 ? true : false"
                    @change="getClassify">
                    <el-option label="产品体验" :value="1" />
                    <el-option label="探店体验" :value="2" />
                </el-select>
            </el-form-item>
            <el-form-item label="分类" prop="evaluation_class_id">
                <el-select v-model="form.evaluation_class_id" filterable placeholder="商品分类" :loading="classifyLoading"
                    :disabled="already_issues_num > 0 ? true : false" @change="onSelectEC">
                    <el-option v-for="item in classifyList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <el-select v-if="form.type !== 2" style="margin-left: 10px;" v-model="form.commodity_type"
                    :disabled="already_issues_num > 0 ? true : false" placeholder="商品类型">
                    <el-option label="展示商品" :value="2" />
                    <el-option label="测评商品" :value="1" />
                </el-select>
            </el-form-item>
            <!-- </div> -->
            <el-form-item v-if="form.commodity_type === 1 || form.type === 2" label="测评类型" prop="order_type">
                <el-checkbox-group v-model="form.order_type" :disabled="already_issues_num > 0 ? true : false">
                    <el-checkbox :label="1">平台种草</el-checkbox>
                    <el-checkbox :label="2">问卷调查</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item v-if="form.order_type.includes(1) && (form.commodity_type === 1 || form.type === 2)" label="发布渠道"
                prop="channels">
                <div v-if="platformListLoading" style="display:flex; align-items:center;">
                    <i style="font-size:1rem;" class="el-icon-loading"></i>
                    <span style="margin-left:6px;">Loading...</span>
                </div>
                <el-checkbox-group v-else v-model="form.channels" :disabled="type !== 'add' && editData.already_issues_num !==null && editData.already_issues_num > 0">
                    <el-checkbox v-for="item in platformList" :key="item.id" :label="item.id">{{
                        item.name
                    }}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="产品名称" prop="name">
                <el-input style="max-width: 690px;" v-model="form.name" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="封面 (竖)" prop="cover_img_vertical">
                <upload-one v-model="form.cover_img_vertical" width="530px" height="330px"></upload-one>
            </el-form-item>
            <el-form-item label="封面 (横)" prop="cover_img">
                <upload-one v-model="form.cover_img" width="530px" height="330px"></upload-one>
                <p style="font-size: .8rem; line-height: 1.5rem; margin: 0; color: #bebfc2;">(380*214倍数)</p>
            </el-form-item>
            <el-form-item label="轮播图" prop="commodity_img">
                <upload-list :list="form.commodity_img" width="530px" height="330px"></upload-list>
                <p style="font-size: .8rem; line-height: 1.5rem; margin: 0; margin-top: -10px; color: #bebfc2;">(414*414倍数)
                </p>
            </el-form-item>
            <el-form-item label="价值" prop="worth">
                <el-input style="max-width: 320px;" v-model="form.worth" placeholder="请输入价值"></el-input>
            </el-form-item>
            <el-form-item label="商家" prop="merchant_id">
                <el-select :loading="merchantLoading" v-model="form.merchant_id" filterable placeholder="请选择">
                    <el-option v-for="item in merchantList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </el-form-item>

            <el-form-item v-if="form.order_type.includes(2)" label="问卷模板" prop="questionnaire_id">
                <el-select v-model="form.questionnaire_id" filterable placeholder="请选择"
                    :disabled="is_order_questionnaire === 0 ? false : true" :loading="questionnaireLoading">
                    <el-option v-for="item in questionnaireList" :key="item.id" :label="item.title" :value="item.id" />
                </el-select>
            </el-form-item>




            <template v-if="form.commodity_type !== 2">
                <!-- <el-form-item label="发行数量" prop="issues_num"
                    v-if="this.type !== 'add' || (form.order_type.includes(2) && !form.order_type.includes(1))">
                    <el-input style="max-width: 320px;" v-model.number="form.issues_num" placeholder="请输入内容"
                        :disabled="!(form.order_type.includes(2)) || (form.order_type.length > 1)"></el-input>
                </el-form-item> -->

                <el-form-item label="发行数量" prop="issues_num">
                    <el-input style="max-width: 320px;" v-model.number="form.issues_num" placeholder="请输入内容"></el-input>
                </el-form-item>

                <el-form-item label="赠送积分" prop="integarl_num">
                    <el-input style="max-width: 320px;" v-model.number="form.integarl_num" placeholder="请输入内容"></el-input>
                </el-form-item>
            </template>




            <template v-if="form.order_type.includes(1) && (form.commodity_type === 1 || form.type === 2)">
                <el-form-item label="是否商户活动">
                    <el-switch v-model="form.is_merchant_activity">
                    </el-switch>
                </el-form-item>
                <!-- <el-form-item label-width="0">
                    <div class="platSelect">
                        <div style="width: 110px;padding-right:12px;display: flex;font-size: 14px;color: #606266;box-sizing: border-box;">
                            <span class="required" style="color: red;user-select:none;margin-left:4px;">*</span>
                            <div style="font-size: 14px;color: #606266;text-align:right;vertical-align: middle;font-weight: 700;">
                                请选择推广平台（多选）
                            </div>
                        </div>
                        <div>
                            <div style="display: flex;margin-bottom: 20px;" v-for="(platItem, platIndex) in form.channelsDatas"
                            :key="platIndex">
                                <el-form-item :prop="'channelsDatas.' + platIndex + '.id'" style="margin-left: 0px;"
                                    :rules="[{ required: true, message: '请选择推广平台', trigger: 'change' }]">
                                    <el-select v-model="platItem.id" placeholder="请选择推广平台" @change="selectChange(platItem.id)">
                                        <el-option v-for="item in platformList" :key="item.id" :label="item.name"
                                            :disabled="item.disabled" :value="item.id" />
                                    </el-select>
                                </el-form-item>

                                <el-form-item :prop="'channelsDatas.' + platIndex + '.issues_num'" style="margin-left: 20px;"
                                    :rules="[{ required: true, message: '请输入推广人数', trigger: 'blur' }, { validator: validatePeopleNum, trigger: 'blur' }]">
                                    <el-input style="max-width: 200px;" v-model.number="platItem.issues_num" clearable
                                        placeholder="请输入最大推广人数" @input="platItem.issues_num=platItem.issues_num.replace(/[^\d.]/g,'')"></el-input>
                                </el-form-item>
                                <div>
                                    <el-button type="danger" style="margin-left: 20px;" v-if="form.channelsDatas.length !== 1"
                                        @click="deletePlat(platIndex)">删除</el-button>
                                    <el-button type="primary" style="margin-left: 20px;" @click="addPlat"
                                        v-if="platIndex === form.channelsDatas.length - 1">继续添加平台</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </el-form-item> -->
            </template>



            <template v-if="form.commodity_type !== 2">
                <el-form-item label="招募时间" prop="filteDateRange">
                    <el-date-picker v-model="form.filteDateRange" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" style="width:390px;" end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss" @change="onChangeDateRange">
                    </el-date-picker>
                </el-form-item>

            </template>

            <template v-if="form.order_type.includes(1) && form.commodity_type === 1">
                <el-form-item label="初稿截止时间" prop="end_first_submit_at">
                    <el-date-picker v-model="form.end_first_submit_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间" />
                </el-form-item>
                <el-form-item label="终稿截止时间" prop="end_final_submit_at">
                    <el-date-picker v-model="form.end_final_submit_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间" />
                </el-form-item>
            </template>

            <template v-if="form.type === 2">
                <el-form-item label="开始探店时间" prop="start_to_store_at">
                    <el-date-picker v-model="form.start_to_store_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间" />
                </el-form-item>
                <el-form-item label="结束探店时间" prop="end_to_store_at">
                    <el-date-picker v-model="form.end_to_store_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间" />
                </el-form-item>
            </template>

            <el-form-item v-if="form.order_type.includes(2)" label="问卷截止时间" prop="end_questionnaire_at">
                <el-date-picker v-model="form.end_questionnaire_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间" />
            </el-form-item>

            <template v-if="form.commodity_type !== 2">
                <el-form-item label="活动结束时间" prop="finish_at">
                    <el-date-picker v-model="form.finish_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择日期时间" />
                </el-form-item>
            </template>

            <el-form-item label="详情介绍" prop="details">
                <tinymce :height="400" v-model="form.details" :value="form.details" ref="tinymce" />
            </el-form-item>

            <el-form-item label="权重" prop="sort">
                <el-input-number v-model="form.sort" :min="1" :max="9999"></el-input-number>
            </el-form-item>

            <el-form-item>
                <el-button @click="trunOff">返回</el-button>
                <el-button type="primary" @click="onSubmit">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import UploadList from "@/components/UploadList/index.vue";
import Tinymce from "@/components/Tinymce";
import { review } from "@/api/review"
import { forEach } from "jszip";

export default {
    data() {
        var valiTimeCorrectness = ({ field }, value, callback) => {
            const { finish_at, end_first_submit_at, start_to_store_at, end_at } = this.form
            const formatTime = new Date(value)

            console.log('rule', field);
            console.log('value', value);


            switch (field) {
                // case 'end_at':
                //     if (formatTime < new Date()) callback(new Error('招募截止时间不能选择过去'))
                //     break;
                case 'end_first_submit_at':
                    if (formatTime < new Date(end_at)) { callback(new Error('初稿截止时间不能早于招募截止时间')); } else {
                        callback()
                    }
                    break;
                case 'end_final_submit_at':
                    if (formatTime < new Date(end_first_submit_at)) { callback(new Error('终稿截止时间不能早于初稿截止时间')); }
                    else { callback() }
                    break;
                // case 'start_to_store_at':
                //     if (formatTime < new Date()) callback(new Error('开始探店时间不能选择过去'))
                //     break;
                case 'end_to_store_at':
                    if (formatTime < new Date(start_to_store_at)) { callback(new Error('结束探店时间不能早于开始探店时间')); } else {
                        callback()
                    }
                    break;
                case 'end_questionnaire_at':
                    if (formatTime < new Date(end_at)) { callback(new Error('问卷截止时间不能早于招募截止时间')) } else {
                        callback()
                    }
                    break;
                case 'finish_at':
                    if (formatTime < new Date(end_at)) { callback(new Error('活动结束时间不能早于招募截止时间')) } else {
                        callback()
                    }
                    break;
                default:
                    throw Error("喵喵喵?")
            }

            // callback();
        }

        return {
            validateSelect: (rule, value, callback) => {
                if (this.form.channelsDatas.length > 1) {
                    this.form.channelsDatas.forEach((item, index) => {
                        console.log(item)
                        if (item.id === value) {
                            callback(new Error('推广平台重复'))
                        } else {
                            callback()
                        }
                    })
                } else {
                    callback()
                }

            },
            validatePeopleNum: (rule, value, callback) => { value <= 0 ? callback(new Error('推广人数要大于0')) : callback(); },
            value: true,
            rules: {
                type: [
                    { required: true, message: "请选择测评类型", trigger: 'blur' }
                ],
                name: [
                    { required: true, message: "请输入产品名称", trigger: 'blur' }
                ],
                evaluation_class_id: [
                    { required: true, message: "请选择分类", trigger: 'blur' }
                ],
                order_type: [
                    { type: 'array', required: true, message: '请至少选择一个测评类型', trigger: 'change' }
                ],
                cover_img_vertical: [
                    { required: true, message: "请上传封面 (竖)", trigger: 'blur' }
                ],
                cover_img: [
                    { required: false, message: "请上传封面 (横)", trigger: 'blur' }
                ],
                channels: [
                    { required: true, message: '请至少选择一个推广平台', trigger: 'change' },
                ],
                // channels_num: [
                //     // {  required: true, message: '请输入推广人数', trigger: 'blur' },
                //     { validator: valiTimeCorrectness, trigger: "blur" }
                // ],
                worth: [
                    { required: true, message: "请输入价值", trigger: 'blur' },
                    { pattern: /^\d+(,\d{3})*(\.\d{1,2})?$/, message: "请输入正确的价格" }
                ],
                questionnaire_id: [
                    { required: true, message: "请选择问卷模板", trigger: 'blur' }
                ],
                issues_num: [
                    { required: true, message: "请输入发行数量", trigger: 'blur' },
                    { type: 'number', message: "请输入数值类型", trigger: 'blur' },
                    { pattern: /^[1-9]\d*$/, message: "请输入正整数" }
                ],
                integarl_num: [
                    { required: true, message: "请输入赠送积分的数量", trigger: 'blur' },
                    { type: 'number', message: "请输入数值类型", trigger: 'blur' },
                    { pattern: /^[1-9]\d*$/, message: "请输入正整数" }
                ],
                commodity_img: [
                    { type: 'array', required: true, message: '请至少上传一张轮播图', trigger: 'change' }
                ],
                merchant_id: [
                    { required: true, message: "请选择商家", trigger: 'blur' }
                ],
                finish_at: [
                    { required: true, message: "请选择活动结束时间", trigger: 'blur' },
                    { validator: valiTimeCorrectness, trigger: "blur" }
                ],
                end_first_submit_at: [
                    { required: true, message: "请选择初稿截止时间", trigger: 'blur' },
                    { validator: valiTimeCorrectness, trigger: "blur" }
                ],
                end_final_submit_at: [
                    { required: true, message: "请选择终稿截止时间", trigger: 'blur' },
                    { validator: valiTimeCorrectness, trigger: "blur" }
                ],
                start_to_store_at: [
                    { required: true, message: "请选择开始探店时间", trigger: 'blur' },
                    // { validator: valiTimeCorrectness, trigger: "blur" }
                ],
                end_to_store_at: [
                    { required: true, message: "请选择结束探店时间", trigger: 'blur' },
                    { validator: valiTimeCorrectness, trigger: "blur" }
                ],
                end_questionnaire_at: [
                    { required: true, message: "请选择问卷截止时间", trigger: 'blur' },
                    { validator: valiTimeCorrectness, trigger: "blur" }
                ],
                details: [
                    { required: true, message: "请输入详情", trigger: 'blur' }
                ],
                filteDateRange: [
                    { type: 'array', required: true, message: '请选择招募时间', trigger: 'blur' }
                ]
            },
            merchantLoading: false,
            merchantList: [],
            platformListLoading: false,
            platformList: [],
            platformListData: [],
            classifyLoading: false,
            classifyList: [],
            questionnaireLoading: false,
            questionnaireList: [],
            questionnaireLists: [],
            is_order_questionnaire: 0,
            already_issues_num: 0,
            form: {
                filteDateRange: [],
                channelsDatas: [
                    {
                        id: '',
                        name: '',
                        issues_num: ''
                    }
                ],
                is_merchant_activity: true,
                id: null,
                type: 1,
                name: '',
                commodity_type: null,
                evaluation_class_id: null,
                worth: '',
                channels: 1,
                // channels_num: 10,
                issues_num: 1,
                integarl_num: 1,
                merchant_id: null,
                questionnaire_id: null,
                cover_img: null,
                cover_img_vertical: null,
                commodity_img: [],
                order_type: [],
                start_at: null,
                end_at: null,
                finish_at: null,
                end_first_submit_at: null,
                end_final_submit_at: null,
                start_to_store_at: null,
                end_to_store_at: null,
                end_questionnaire_at: null,
                details: '',
                sort: 1
            },
        }
    },
    components: { UploadList, Tinymce },
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 模式
        type: {
            default: 'add',
            type: String
        },
        // 编辑的数据
        editData: null | Object
    },
    methods: {
        selectChange(value) {
            this.platformList = this.platformListData.map(dataItem => {
                dataItem.disabled = false
                this.form.channelsDatas.forEach(addItem => {
                    if (dataItem.id === addItem.id) {
                        dataItem.disabled = true
                        addItem.name = dataItem.name
                    }
                });
                return dataItem
            })
        },
        addPlat() {
            this.form.channelsDatas.push({
                id: '',
                name: '',
                issues_num: ''
            })
        },
        deletePlat(platIndex) {
            this.form.channelsDatas.splice(platIndex, 1)
            this.selectChange()
        },
        trunOff() {
            this.showModal = false
        },
        onChangeDateRange(t) {
            this.form.start_at = t[0]
            this.form.end_at = t[1]
        },
        async initOption() {
            this.merchantLoading = true
            this.platformListLoading = true
            this.questionnaireLoading = true

            const { data: merchant } = await review.merchant({ state: 1 })
            const { data: platformList } = await review.platformList()
            const questionnaireRes = await review.questionnaireList({ id: this.form.questionnaire_id })

            let list = platformList.map(item => {
                item.disabled = false
                return item
            })

            this.merchantList = merchant
            this.platformListData = [...list]
            this.platformList = this.platformListData.map(dataItem => {
                dataItem.disabled = false
                this.form.channelsDatas.forEach(addItem => {
                    if (dataItem.id === addItem.id) {
                        dataItem.disabled = true
                        addItem.name = dataItem.name
                    }
                });
                return dataItem
            })
            this.questionnaireList = questionnaireRes.data

            this.merchantLoading = false
            this.platformListLoading = false
            this.questionnaireLoading = false
        },
        onSelectEC() {
            if (!this.form.commodity_type) {
                this.form.commodity_type = 1
            }
        },
        handleUpdateFormModelByModalType() {
            const handlers = {
                add: () => {
                    this.form = {
                        id: null,
                        type: 1,
                        name: '',
                        commodity_type: null,
                        evaluation_class_id: null,
                        worth: '',
                        channels: [],
                        issues_num: 1,
                        integarl_num: 1,
                        merchant_id: null,
                        questionnaire_id: null,
                        cover_img: null,
                        cover_img_vertical: null,
                        commodity_img: [],
                        order_type: [],
                        start_at: null,
                        end_at: null,
                        finish_at: null,
                        end_first_submit_at: null,
                        end_final_submit_at: null,
                        start_to_store_at: null,
                        end_to_store_at: null,
                        end_questionnaire_at: null,
                        details: '',
                        sort: 1,
                        channelsDatas: [
                            {
                                id: '',
                                name: '',
                                issues_num: ''
                            }
                        ],
                        filteDateRange: [],
                        is_merchant_activity: true,
                    }
                },
                edit: () => {
                    let { channels, start_at, channelsDatas, is_merchant_activity, id, type, name, evaluation_class_id, order_type, commodity_type, cover_img, cover_img_vertical, commodity_img, worth, issues_num, integarl_num, questionnaire_id, is_order_questionnaire, merchant_id, finish_at, end_at, end_first_submit_at, end_final_submit_at, start_to_store_at, end_to_store_at, end_questionnaire_at, details, already_issues_num, sort } = this.editData

                    let formated_order_type
                    if (channelsDatas) {
                        channelsDatas = channelsDatas.filter(item => item.state === 1)
                        if (channelsDatas.length === 0) {
                            channelsDatas = [{
                                id: '',
                                name: '',
                                issues_num: ''
                            }]
                        }
                    } else {
                        channelsDatas = [{
                            id: '',
                            name: '',
                            issues_num: ''
                        }]
                    }
                    switch (order_type) {
                        case 1:
                            formated_order_type = [1]
                            break
                        case 2:
                            formated_order_type = [2]
                            break
                        case 3:
                            formated_order_type = [1, 2]
                            break
                        default:
                            formated_order_type = []
                    }
                    const formated_channels = channels ? channels.toString().split(',').map((item) => item * 1) : []

                    console.log(formated_channels);


                    let filteDateRange
                    if (start_at && end_at) {
                        filteDateRange = [start_at, end_at]
                    } else {
                        filteDateRange = []
                    }


                    this.form = {
                        id,
                        type,
                        name,
                        evaluation_class_id,
                        order_type: formated_order_type,
                        commodity_type,
                        cover_img,
                        cover_img_vertical,
                        commodity_img,
                        questionnaire_id,
                        worth,
                        issues_num,
                        integarl_num,
                        merchant_id,
                        channels: formated_channels,
                        start_at,
                        end_at,
                        finish_at,
                        end_first_submit_at,
                        end_final_submit_at,
                        start_to_store_at,
                        end_to_store_at,
                        end_questionnaire_at,
                        details,
                        sort,
                        channelsDatas: channelsDatas,
                        filteDateRange: filteDateRange,
                        is_merchant_activity: is_merchant_activity ? true : false,
                    }
                    this.is_order_questionnaire = is_order_questionnaire
                    this.already_issues_num = already_issues_num
                }
            }

            handlers[this.type]()
        },
        async getClassify(_, clear = true) {
            if (clear) {
                this.form.evaluation_class_id = null
            }
            this.classifyLoading = true
            const { data } = await review.classify(this.form.type)
            this.classifyList = data
            this.classifyLoading = false
        },
        onSubmit() {
            const { order_type } = this.form

            this.$refs["form"].validate(async valid => {
                if (valid) {
                    let formated_order_type
                    if (order_type.length === 2) {
                        formated_order_type = 3
                    } else if (order_type.includes(1)) {
                        formated_order_type = 1
                    } else if (order_type.includes(2)) {
                        formated_order_type = 2
                    }
                    this.form.is_merchant_activity = this.form.is_merchant_activity ? 1 : 0
                    try {
                        await review.create({
                            ...this.form,
                            order_type: formated_order_type,
                            channels: this.form.channels.toString()
                        })
                        this.$message({
                            message: `${this.type === 'add' ? '新建' : '编辑'}数据成功!`,
                            type: 'success'
                        });
                        this.$emit("onUpdate")
                        this.trunOff()
                    } catch {
                        this.$message.error('出错了!');
                    }
                } else {
                    this.$message({
                        message: '表单某项存在空值',
                        type: 'warning'
                    });
                }
            })
        },
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
        title() {
            const { type } = this

            const title = {
                add: "新建数据",
                edit: "编辑数据"
            }

            return title[type]
        }
    },
    created() {
        this.handleUpdateFormModelByModalType()
        this.initOption()
        this.getClassify(null, false)
    }
    // watch: {
    //     show(newVal) {
    //         if (newVal) {
    //             this.handleUpdateFormModelByModalType()
    //             this.initOption()
    //             this.getClassify()
    //         }
    //     }
    // }
}
</script>

<style lang="scss" scoped>
.platSelect {
    display: flex;

}
</style>

<style lang="scss">
.left0 {
    .el-form-item__content {
        margin-left: 20px !important;
    }
}
</style>